import React from 'react';
import { ClaimsStatsComponent } from './ClaimsStats';
import { Box } from '@material-ui/core';

/**
 * Overview page for Claims that displays statistics
 */
export function ClaimsOverviewPage() {
  return (
    <Box>
      <ClaimsStatsComponent />
    </Box>
  );
}

export default ClaimsOverviewPage;
